import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import InputTextField from '../../../../../../component/input/inputTextField';
import FilterSelect from '../../../../../../component/select/filterSelect';
import { MenuItem, Typography } from '@mui/material';

import { ButtonContained } from '../../../../../../component/mui-custom/MuiCustom';
import { useDispatch, useSelector } from 'react-redux';
import { setLoading, unsetLoading } from '../../../../../../store/slice/loading/loading.slice';
import { swalError, swalSuccess } from '../../../../../../component/notification/swal';

// API
import { TypesApi, createType } from '../../../../../../api/type/type.api';
import { ProjectApi } from '../../../../../../api/project/project.api';
import TableRowCommon from '../../../../../../component/table/TableRowCommon';
import TableCustom from '../../../../../../component/table/tableCustom';
import { RouteImage } from '../../../../../../assets/routeImage';
import { handleTypingNumber } from '../../../../../../utils/app.utils';
import AutocompleteSelect from '../../../../../../component/select/autoCompleteSelect';
type Props = {
    fetchData: () => void;
    toggleModal: () => void;

}
type typeErrorMessage = {
    typeNo?: string;
    typeName?: string;
}
const initialErrorMessage: typeErrorMessage = {
    typeNo: ``,
    typeName: ``,
}

const AddTypes: React.FC<Props> = (props: Props) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const idFiscalYear = useSelector((state: any) => state?.fiscalYear?.idFiscalYear);

    const [types, setTypes] = useState<createType>({
        typeStatus: t("STATUS.ACTIVE"),
        typeNo: "",
        typeName: "",
        idFiscalYear: idFiscalYear,
        isActivities: true,
        isEquipment: true,
        detailProjectStatus: []

    })
    const [errorMessage, setErrorMessage] = useState<typeErrorMessage>(initialErrorMessage);
    const [detailProjectStatus, setDetailProjectStatus] = useState<any>(null);
    const [projectStatus, setProjectStatus] = useState<any[]>([]);
    const [idProjectStatusType, setIdProjectStatusType] = useState<number>(Number);
    const [idStatus, setIdStatus] = useState<number>(Number);
    const [projectStatusName, setProjectStatusName] = useState<string>("");

    const clearErrorMessage = () => setErrorMessage(initialErrorMessage)

    const handleDeleteProjectStatusList = (index: number) => {
        setTypes((prev) => ({
            ...prev,
            detailProjectStatus: prev?.detailProjectStatus?.filter((_, i) => i !== index)
        }))
    }
    const handleChangePercentType = (value: any, index: number) => {
        setTypes((prev) => ({
            ...prev,
            detailProjectStatus: prev?.detailProjectStatus?.map((list, i: number) => {
                if (i === index) {
                    return {
                        ...list,
                        projectStatusPercent: value
                    }
                } else return list
            })
        }))
    }


    const headCells = [
        {
            id: "idProject",
            disablePadding: false,
            align: 'center',
            width: 10,
            label: 'ลำดับ'
        },
        {
            id: "projectName",
            disablePadding: false,
            align: "left",
            width: 80,
            sortable: true,
            label: "ขั้นตอนการดำเนินโครงการ"
        },
        {
            id: 'percent',
            width: 55,
            align: 'center',
            label: "ร้อยละความคืบหน้าโครงการ"
        },
        {
            id: '-',
            width: 10,
            class: true,
            label: ""
        }
    ];
    const renderData = (objData: any, index: number) => {
        let dIndex: any = index + 1
        const { id, seq, projectStatusName, projectStatusPercent } =
            objData;

        const objRenderData = {
            key: dIndex,
            id: id,
            obj: objData,
            columns: [
                { option: "TEXT", align: "center", width: 10, label: index + 1 },
                {
                    option: "TEXT",
                    align: "left",
                    label: projectStatusName || "-",
                },
                {
                    option: "COMPONENT",
                    align: "center",
                    style: { margin: "0 auto" },
                    component:
                        <div className='w-full flex justify-center items-center'>
                            <span className='w-[5.7rem]'>
                                <InputTextField
                                    disabledAutoComplete
                                    onkeypress={handleTypingNumber}
                                    onchange={(e: React.ChangeEvent<HTMLInputElement>) => handleChangePercentType(Number(e.target.value) > 100 ? 0 : Number(e.target.value), index)}
                                    endAdornment={<p>%</p>}
                                    value={projectStatusPercent}
                                />
                            </span>
                        </div>
                },
                {
                    option: "COMPONENT",
                    class: true,
                    width: 50,
                    component:
                        <div className='cursor-pointer' onClick={() => handleDeleteProjectStatusList(index)}>
                            <img src={RouteImage.delete} alt="delete-icon" />
                        </div>
                }
            ],
        };
        return <TableRowCommon

            {...objRenderData}
        />;
    };

    const handleSubmit = async (event: React.FormEvent) => {
        event.preventDefault();
        if (!types.typeNo) {
            setErrorMessage((prev) => ({ ...prev, typeNo: 'กรุณาระบุรหัสประเภทโครงการ' }))
            return;
        } else if (!types.typeName) {
            setErrorMessage((prev) => ({ ...prev, typeName: 'กรุณาระบุคำขยายความประเภทโครงการ' }))
            return;
        }
        let condition: createType = {
            ...types,
            detailProjectStatus: types?.detailProjectStatus?.map((list: any) => {
                return {
                    idStatus: list?.idStatus,
                    statusPercent: list?.projectStatusPercent === 0 ? null : list?.projectStatusPercent,
                    statusName: list?.projectStatusName
                }
            })
        }
        console.log(condition)
        dispatch(setLoading())
        await TypesApi.createType(condition)
            .then(res => {
                if (res.status === 200) {
                    dispatch(unsetLoading())
                    swalSuccess(res.data?.description)
                }
            })
            .catch(error => {
                dispatch(unsetLoading())
                swalError(error.response?.data?.description)
                console.log(error)
            })
            .finally(() => {
                props.fetchData()
                props.toggleModal()
            })
    }


    useEffect(() => {
        const handleGetProjectStatusAll = async () => {
            await ProjectApi.getAllProjectStatus()
                .then(res => {
                    if (res.status === 200) {
                        setProjectStatus(res.data?.result);
                    }
                })
                .catch(error => {
                    throw new Error("can't get data from API", error);
                })
        }
        handleGetProjectStatusAll()
    }, [])

    return (
        <form className='w-full' onSubmit={handleSubmit}>
            <div className='mt-8 gap-5 grid grid-cols-12'>
                <span className='col-span-12 md:col-span-3 lg:col-span-3'>
                    <InputTextField
                        helperText={errorMessage.typeNo}
                        onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                            clearErrorMessage()
                            setTypes((prev) => ({ ...prev, typeNo: e.target.value }))
                        }}
                        value={types.typeNo}
                        heading='รหัสประเภทโครงการ'
                    />
                </span>
                <span className='col-span-12 md:col-span-9 lg:col-span-9'>
                    <InputTextField
                        helperText={errorMessage.typeName}
                        onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                            clearErrorMessage()
                            setTypes((prev) => ({ ...prev, typeName: e.target.value }))
                        }}
                        value={types.typeName}
                        heading='คำขยายความประเภทโครงการ'
                    />
                </span>
                <span className='col-span-12 md:cols-span-4 lg:col-span-4'>
                    <FilterSelect
                        required
                        heading={t("กิจกรรมย่อย")}
                        renderValue={() => types.isActivities === true ?
                            <Typography className='text-light_success'> {t("มี")}</Typography>
                            : <Typography className='text-danger'>{t('ไม่มี')}</Typography>}
                        label={t('STATUS.LABEL')}
                        selectId="select-fiscal-year"
                        value={types.isActivities}
                        labelId="label-fiscal-year"
                        onchange={(event: React.ChangeEvent<HTMLSelectElement>) => setTypes((prev) => ({ ...prev, isActivities: Number(event.target.value) === 1 ? true : false }))}
                        options={[
                            <MenuItem key="1" value={1}>
                                <Typography className='text-light_success'> {t("มี")}</Typography>
                            </MenuItem>,
                            <MenuItem key="2" value={2}>
                                <Typography className='text-danger'>{t('ไม่มี')}</Typography>
                            </MenuItem>
                        ]}
                    />
                </span>
                <span className='col-span-12 md:cols-span-4 lg:col-span-4'>
                    <FilterSelect
                        required
                        heading={t("รายงานครุภัณฑ์")}
                        renderValue={() => types.isEquipment === true ?
                            <Typography className='text-light_success'> {t("มี")}</Typography>
                            : <Typography className='text-danger'>{t('ไม่มี')}</Typography>}
                        label={t('STATUS.LABEL')}
                        selectId="select-fiscal-year"
                        value={types.isEquipment}
                        labelId="label-fiscal-year"
                        onchange={(event: React.ChangeEvent<HTMLSelectElement>) => setTypes((prev) => ({ ...prev, isEquipment: Number(event.target.value) === 1 ? true : false }))}
                        options={[
                            <MenuItem key="1" value={1}>
                                <Typography className='text-light_success'> {t("มี")}</Typography>
                            </MenuItem>,
                            <MenuItem key="2" value={2}>
                                <Typography className='text-danger'>{t('ไม่มี')}</Typography>
                            </MenuItem>
                        ]}
                    />
                </span>
                <span className='col-span-12 md:cols-span-4 lg:col-span-4'>
                    <FilterSelect
                        required
                        heading={t("สถานะการใช้งาน")}
                        renderValue={() => types.typeStatus === t("STATUS.ACTIVE") ?
                            <Typography className='text-light_success'> {t("STATUS.ACTIVE")}</Typography>
                            : <Typography className='text-danger'>{t('STATUS.INACTIVE')}</Typography>}
                        label={t('STATUS.LABEL')}
                        selectId="select-status-usage"
                        value={types.typeStatus}
                        labelId="label-status-usage"
                        onchange={(event: React.ChangeEvent<HTMLSelectElement>) => setTypes((prev) => ({ ...prev, status: Number(event.target.value) === 1 ? true : false }))}
                        options={[
                            <MenuItem key="1" value={1}>
                                <Typography className='text-light_success'> {t("STATUS.ACTIVE")}</Typography>
                            </MenuItem>,
                            <MenuItem key="2" value={2}>
                                <Typography className='text-danger'>{t('STATUS.INACTIVE')}</Typography>
                            </MenuItem>
                        ]}
                    />
                </span>
                <span className='col-span-12 md:cols-span-4 lg:col-span-4'>
                    <AutocompleteSelect
                        freeSolo
                        onInputChange={(_, value) => {
                            setIdStatus(0)
                            setProjectStatusName(value)
                        }}
                        heading={t("สถานะการติดตาม")}
                        value={projectStatus?.find((list: any) => list?.idStatus === idStatus) || null}
                        labelId="label-tracking"
                        getOptionLabel={(option: any) => `${option?.projectStatusName}`}
                        onChange={(e, value: any) => {
                            setIdProjectStatusType(value?.idProjectStatusType)
                            setIdStatus(value?.idStatus)
                            if (value) {
                                setDetailProjectStatus(value);
                            }
                        }}

                        options={projectStatus?.filter((list: any) =>
                            list?.idStatus !==
                            types?.detailProjectStatus?.find((data: any) =>
                                data?.idStatus === list?.idStatus
                            )?.idStatus
                        ) || []}
                    />
                </span>
                <span className='col-span-12 md:col-span-12 lg:col-span-3'>
                    <ButtonContained
                        onClick={() => {
                            if (idStatus) {
                                setTypes((prev: any) => ({
                                    ...prev,
                                    detailProjectStatus: [...prev?.detailProjectStatus, detailProjectStatus]
                                }))
                            } else {
                                let condition = {
                                    projectStatusName: projectStatusName,
                                    idStatus: null,
                                    statusPercent: null
                                }
                                setTypes((prev: any) => ({
                                    ...prev,
                                    detailProjectStatus: [...prev?.detailProjectStatus, condition]
                                }))
                            }
                            // console.log(projectStatusName)
                        }
                        }
                        sx={{ mt: 4, maxWidth: 190 }}>
                        เพิ่มสถานะการติดตาม
                    </ButtonContained>
                </span>
                <span className='mt-2 col-span-12'>
                    <TableCustom
                        tableMinWidth={1040}
                        tableFixedWidth
                        customScroll
                        hidePagination
                        page={0}
                        pageLimit={25}
                        sortBy={""}
                        sortType={"ASC"}
                        headCells={headCells}
                        rowCount={1}
                        rowsData={types?.detailProjectStatus && types.detailProjectStatus?.map((data: any, i: any) => {
                            return renderData(data, i)
                        }) || []}
                        onSort={() => { }}
                        setPageLimit={() => { }}
                        setPage={() => { }}
                    />
                </span>
                <span className='mt-3 col-span-12 flex justify-center items-center'>
                    <ButtonContained
                        type='submit'
                        sx={{ maxWidth: 105 }}
                    >
                        {t("BUTTON.SUBMIT")}
                    </ButtonContained>
                </span>
            </div>
        </form>
    )
}

export default AddTypes